export default {
  requiredMessagesWrapper: {
    textAlign: 'right',
  },
};
